import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useData } from '../../contexts/DataContext';
import AttendanceCalendar from '../Attendance/AttendanceCalander';

const MyAttendance = () => {
  const { attendance, checkIn, checkOut } = useData();
  
  
  const { currentUser } = useAuth();

  const myAttendance = attendance.filter(a => a.userId === currentUser?.id);
  // const todayRecord = myAttendance.find(a => a.date === today);




  const today = new Date().toISOString().split('T')[0];
const todayAttendance = attendance.find(record => 
  (record.userId === currentUser?.id || record.userId === currentUser?.uid) && 
  record.date === today
);

const hasCheckedIn = todayAttendance && todayAttendance.checkIn;
const hasCheckedOut = todayAttendance && todayAttendance.checkOut;
  return (
    <div className="my-attendance">
      <div className="page-header">
        <h2>My Attendance</h2>
      </div>

      <div className="attendance-actions">
        <div className="attendance-card">
          <h3>Today: {new Date().toLocaleDateString()}</h3>
          <div className="attendance-buttons">
          {!hasCheckedIn ? (
  <button className="btn btn-success" onClick={checkIn}>
    <i className="fas fa-sign-in-alt"></i>
    Check In
  </button>
) : !hasCheckedOut ? (
  <button className="btn btn-warning" onClick={checkOut}>
    <i className="fas fa-sign-out-alt"></i>
    Check Out
  </button>
) : (
  <div className="completed-day">
    <i className="fas fa-check-circle"></i>
    Day Completed
  </div>
)}
          </div>
        </div>
      </div>

      <div className="attendance-history">
        <h3>Attendance History</h3>
        <AttendanceCalendar />
        <div className="attendance-table">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Check In</th>
                <th>Check Out</th>
                <th>Hours</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {myAttendance.map(record => (
                <tr key={record.id}>
                  <td>{new Date(record.date).toLocaleDateString()}</td>
                  <td>{record.checkIn}</td>
                  <td>{record.checkOut || '-'}</td>
                  <td>{record.hoursWorked || 0} hrs</td>
                  <td>
                    <span className={`status-badge status-${record.status}`}>
                      {record.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MyAttendance;
